import { motion } from 'framer-motion';
import styled from 'styled-components';
import { BREAKPOINTS } from 'styles/media';

import {
  BestOfCandidateCardFooter,
  BestOfCandidateCardFooterTitle,
} from '../CommonStyled/BestOfCandidateCardFooter/styled';
import {
  ResourceCardExtraInformationWrapper,
  ResourceCardWrapper,
} from '../Resources/ResourceCard/styled';

export const BestOf2025Wrapper = styled.div`
  min-height: 100svh;

  background-color: #f7f7f7;
  position: relative;
`;

export const BestOf2025ContentWrapper = styled.div`
  padding-top: var(--navbar-height);

  position: relative;

  ${BREAKPOINTS.tablet} {
    padding-top: 0px;
  }
`;

export const BestOf2025Gradient = styled.img.attrs({
  src: '/images/resources/modal-gradient.png',
})`
  width: 100%;

  position: absolute;
  top: 0;
  left: 0;

  object-fit: contain;

  mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0));
`;

//RESOURCES
export const BestOf2025ResourcesWrapper = styled(motion.div).attrs({
  initial: {
    opacity: 0,
  },
  animate: {
    opacity: 1,
  },
  exit: {
    opacity: 0,
  },
})`
  width: 100%;
  max-width: 1440px;

  display: flex;
  flex-direction: column;
  gap: 32px;

  margin: 0 auto;

  padding: 64px 32px 135px 32px;

  ${BREAKPOINTS.tablet} {
    padding: 20px;
  }
`;

export const BestOf2025ResourcesHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 18px;
`;

export const BestOf2025ResourcesHeaderTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  ${BREAKPOINTS.tablet} {
    align-items: center;
  }
`;

export const BestOf2025ResourcesHeaderTitle = styled.h1`
  font-weight: 400;
  font-size: 64px;
  line-height: normal;

  color: #000000;

  ${BREAKPOINTS.tablet} {
    text-align: center;
  }
`;

export const BestOf2025ResourcesContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 25px;

  ${BREAKPOINTS.tablet} {
    flex-direction: column;
  }
`;

export const BestOf2025ResourcesContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 92px;
`;

export const BestOf2025ResourcesContentList = styled(motion.div).attrs({
  initial: {
    opacity: 0,
  },
  animate: {
    opacity: 1,
  },
  exit: {
    opacity: 0,
  },
  transition: {
    duration: 0.2,
    ease: 'easeInOut',
  },
})``;

interface BestOf2025ResourceCardWrapperProps {
  voted: boolean;
}

export const BestOf2025ResourceCardWrapper = styled.div<BestOf2025ResourceCardWrapperProps>`
  min-width: 293px;

  ${ResourceCardExtraInformationWrapper} {
    display: none;
  }

  ${ResourceCardWrapper} {
    ${({ voted }) =>
      voted
        ? `
          border-radius: 20px 20px 0 0 ;
        `
        : ''}
  }
`;

export const BestOf2025ResourceCardVotedWrapper = BestOfCandidateCardFooter;

export const BestOf2025ResourceCardVotedTitle = BestOfCandidateCardFooterTitle;

export const BestOf2025ResourceCardVotedIcon = styled.div`
  width: 40px;
  height: 40px;
  min-width: 40px;
  min-height: 40px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 100%;
  background: #fa7c4a;
  box-shadow: 0 6px 24px 0 rgba(0, 0, 0, 0.1);
`;

export const BestOf2025ResourceCardVotedCategory = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: normal;

  color: #000000;
`;

// AUTO ADVANCE BANNER
export const BestOf2025AutoAdvanceBannerWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;

  padding: 2.5px 20px;

  border-radius: 16px;
  background: rgba(228, 182, 183, 0.1);
`;

export const BestOf2025AutoAdvanceBannerTitle = styled.span`
  font-weight: 400;
  font-size: 18px;
  line-height: normal;

  color: var(--color-text);
`;
